<template>
  <div class="pre-loader">
    <img
      class="pre-loader-gif"
      src="@/assets/Pre-loader.gif"
      alt="Cargando..."
    />
  </div>
</template>

<script>
export default {
  name: "PreLoader",
};
</script>

<style scoped>
.pre-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white; /* Fondo blanco sin transparencia */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.pre-loader-gif {
  width: 60%; /* Ajusta el tamaño según sea necesario */
  height: auto; /* Ajusta el tamaño según sea necesario */
}
</style>
